<template>
    
        <div class="hint" :style="cssProps" v-if="start && end">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" >
            <defs>
                <marker id="arrowhead" 
                        markerWidth="10"
                        markerHeight="7" 
                        stroke="#55CAE3" 
                        fill="none"
                        refX="1" refY="3.5" 
                        orient="auto">
                    <polyline points="0 0, 5 3.5, 0 7" />
                </marker>
                </defs>
                
                <path ref="path" 
                    :class="[{white: !hint.blue}]" 
                    :d="path"
                    marker-end="url(#arrowhead)" />
            </svg>
            <label :class="{white: !hint.blue}" :style="cssProps"> {{ hint.text }} </label>
        </div>
    
</template>

<script>
export default {
    name: 'Hint',
    props: {
        hint: Object,
        show: Boolean
    },
    data(){
        return {
            isSetup: false,
            pathLength: 0,
            start: null,
            end: null,
        }
    },
    computed: {
        cssProps(){
            return {
                "--path" : "path('" + this.animationPath + "')",
                "--path-length" : this.pathLength,
                "--start-offset" : this.pathLength,
                "--label-left" : this.endPoint.x + "px",
                "--label-top" : this.endPoint.y + "px"
            }
        },
        startPoint(){
            if (this.start){
                return {
                            x: this.start.left + this.start.width * .5,
                            y: this.start.top + this.start.height * .5
                        }
            }
            return {
                x: 0,
                y: 0
            }
        },
        endPoint(){
            if (this.end){
                return {
                            x: this.end.left + this.end.width * .5,
                            y: this.end.top + this.end.height * .5
                        }
            }
            return {
                x: 0,
                y: 0
            }
        },
        controlPointX(){
            return this.midpoint.x + Math.sqrt(Math.pow(this.controlDistance, 2) / (Math.pow(this.perpSlope, 2) + 1)) / 2
        },
        controlPointY(){
            return this.midpoint.y + this.perpSlope * (this.midpoint.x - this.controlPointX)
        },
        height() {
            return this.startPoint.y - this.endPoint.y;
        },
        midpoint(){
            return { x : (this.startPoint.x + this.endPoint.x) / 2,
                    y : (this.startPoint.y + this.endPoint.y) / 2 }
        },
        animationPath(){
            return "M " + this.startPoint.x + " " + this.startPoint.y + " Q " +
                        this.controlPointX + " " + this.controlPointY + " " +
                        this.endPoint.x + " " + this.endPoint.y;
        },
        path(){
            return "M " + this.startPoint.x + " " + this.startPoint.y + " Q " +
                        this.controlPointX + " " + this.controlPointY + " " +
                        this.endPoint.x + " " + this.endPoint.y;
        },
        perpSlope(){
            if (this.slope !== 0){
            return -1 / this.slope;
            }
            return 1;
        },
        slope(){
            return (this.startPoint.y - this.endPoint.y) /
                    (this.startPoint.x - this.endPoint.x);
        },
        linearDistance(){
            return Math.sqrt(Math.pow(this.endPoint.x - this.startPoint.x, 2), Math.pow(this.endPoint.y - this.startPoint.y, 2),)
        },
        controlDistance(){
            return this.linearDistance * .75;
        },
        points(){
            return [[this.startPoint.x, this.startPoint.y],
                    [this.controlPointX, this.controlPointY],
                    [this.controlPointX, this.controlPointY],
                    [this.endPoint.x, this.endPoint.y]];
        },
        lerp(a, b, t) { 
            // a virtual line from A to B
            // get the position of a point on this line
            // if(t == .5) the point in in the center of the line
            // 0 <= t <= 1
            let ry = [
                (b[0] - a[0]) * t + a[0], //x
                (b[1] - b[1]) * t + b[1] //y
            ];
            return ry;
        }
        
    },
    methods:{
        centerPoint(element){
            if (element){
                var point = {
                    x: element.offsetLeft + element.offsetWidth * .5,
                    y: element.offsetTop + element.offsetHeight * .5
                }
                return point;
            }
            else{
                return null;
            }
        },
        updateElements(){
            if (this.hint){
                if (this.hint.startId && document.getElementById(this.hint.startId)){
                    this.start = document.getElementById(this.hint.startId).getBoundingClientRect();
                }
                if (this.hint.endId && document.getElementById(this.hint.endId)){
                    this.end = document.getElementById(this.hint.endId).getBoundingClientRect();
                }
            }
        }
    },

    mounted(){
        window.addEventListener('resize', this.updateElements);

        setTimeout(() => {  
            this.updateElements();
        }, 10);

        setTimeout(() => {  
            if (this.$refs.path){
                this.pathLength =  this.$refs.path.getTotalLength();
                this.isSetup = true;
            }
        }, 20);
    }
}
</script>


<style scoped lang="scss">
@import "@/assets/styles/_vars.scss";

    .hint{
        position: absolute;
        top: 0px;
        width: 100vw;
        height: 100vh;
        pointer-events: none;
    }

    label {
        position: absolute;
        left: var(--label-left);
        top: var(--label-top);
        width: 140px;
        font-size: 12px;
        line-height: 15px;
        margin: 5px;

        &.white{
            color: $color-white;
        } 
    }

    path {
        fill: none;
        stroke: $color-blue;
        stroke-width: 2;
        fill: none;
        stroke-dasharray: 3px;

        &.white{
            stroke: $color-white;
        } 
    }

</style>